import { render } from "./DiagnosticsModel.vue?vue&type=template&id=4f2c6474"
import script from "./DiagnosticsModel.vue?vue&type=script&lang=js"
export * from "./DiagnosticsModel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\LuisFolder\\project\\evcharge-ev-server-rocketmq\\evcharge-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__